var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-button',{attrs:{"type":"chain"},on:{"click":_vm.click}})}
var staticRenderFns = []

export { render, staticRenderFns }